import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";

export const productDetailFaqData: AccordionData[] = [
  {
    question: "Who is Defy Medical?",
    answer: (
      <>
        Defy Medical is a telemedicine concierge clinic specializing in Men’s
        Health. Our providers are experts in treating erectile dysfunction,
        along with other Men’s Health issues like low Testosterone, hair loss,
        and more. In addition to our ED treatment, we offer a suite of health
        care services.{" "}
        <a
          href="https://www.defymedical.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#181a20] underline"
        >
          Learn more about us.
        </a>
      </>
    ),
  },
  {
    question: "How does ED treatment work at Defy Medical?",
    answer: (
      <>
        First, you complete a secure online health questionnaire. Then, our
        medical team reviews your history and recommends the best treatment
        options. If prescribed, your medications are shipped directly to your
        door from our pharmacy network.
      </>
    ),
  },
  {
    question: "What is the shipping process for my medication?",
    answer: (
      <>
        Once you place your order, we send it to a pharmacy within our vetted
        network. Your medication is then shipped directly to your door, and
        you’ll receive tracking information once it ships.
      </>
    ),
  },
  {
    question: "What are ED injections?",
    answer: (
      <>
        ED injections like Trimix are compounded medications injected directly
        into the penis. They work quickly—within 5 to 15 minutes—and are highly
        effective, even when oral medications fail.
      </>
    ),
  },
  {
    question: "Can I combine ED medications?",
    answer: (
      <>
        No, combining ED medications—especially injections like Trimix with oral
        ED drugs—can be dangerous. This may result in priapism, a prolonged
        erection requiring emergency care. Always consult a provider for the
        right treatment plan.
      </>
    ),
  },
  {
    question: "How long does it take to see results from ED medications?",
    answer: (
      <>
        Oral ED medications typically take 30 to 60 minutes to work. Injections
        like Trimix work much faster, often within 5 to 15 minutes. Results vary
        depending on the individual and medication type.
      </>
    ),
  },
];
